import angular from 'angular';
import uuidv4 from 'uuid/v4';
import { getProductInfo } from '@/shbdeployer/product';

class AuthenticationController {
  /* @ngInject */
  constructor(
    $async,
    $scope,
    $state,
    $stateParams,
    $window,
    Authentication,
    UserService,
    EndpointService,
    StateManager,
    Notifications,
    SettingsService,
    URLHelper,
    LocalStorage,
    StatusService
  ) {
    this.$async = $async;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.Authentication = Authentication;
    this.UserService = UserService;
    this.EndpointService = EndpointService;
    this.StateManager = StateManager;
    this.Notifications = Notifications;
    this.SettingsService = SettingsService;
    this.URLHelper = URLHelper;
    this.LocalStorage = LocalStorage;
    this.StatusService = StatusService;

    this.logo = this.StateManager.getState().application.logo;
    this.product = getProductInfo();
    this.formValues = {
      Username: '',
      Password: '',
    };
    this.signupFormValues = {
      Email: '',
      Password: '',
    };
    this.state = {
      showOAuthLogin: false,
      showStandardLogin: false,
      showSignupForm: false,
      enableSelfRegistration: false,
      AuthenticationError: '',
      SignupError: '',
      loginInProgress: true,
      signupInProgress: false,
      OAuthProvider: '',
    };

    this.checkForEndpointsAsync = this.checkForEndpointsAsync.bind(this);
    this.checkForLatestVersionAsync = this.checkForLatestVersionAsync.bind(this);
    this.postLoginSteps = this.postLoginSteps.bind(this);

    this.oAuthLoginAsync = this.oAuthLoginAsync.bind(this);
    this.internalLoginAsync = this.internalLoginAsync.bind(this);

    this.authenticateUserAsync = this.authenticateUserAsync.bind(this);
    this.signupUserAsync = this.signupUserAsync.bind(this);

    this.manageOauthCodeReturn = this.manageOauthCodeReturn.bind(this);
    this.authEnabledFlowAsync = this.authEnabledFlowAsync.bind(this);
    this.onInit = this.onInit.bind(this);
  }

  // --- служебные функции ---

  logout(error) {
    this.Authentication.logout();
    this.state.loginInProgress = false;
    this.generateOAuthLoginURI();
    this.LocalStorage.storeLogoutReason(error);
    this.$window.location.reload();
  }

  error(err, message) {
    this.state.AuthenticationError = message;
    if (!err) {
      err = {};
    }
    this.Notifications.error('Ошибка', err, message);
    this.state.loginInProgress = false;
  }

  determineOauthProvider(LoginURI) {
    if (LoginURI.indexOf('login.microsoftonline.com') !== -1) {
      return 'Microsoft';
    } else if (LoginURI.indexOf('accounts.google.com') !== -1) {
      return 'Google';
    } else if (LoginURI.indexOf('github.com') !== -1) {
      return 'Github';
    }
    return 'OAuth';
  }

  generateState() {
    const uuid = uuidv4();
    this.LocalStorage.storeLoginStateUUID(uuid);
    return '&state=' + uuid;
  }

  generateOAuthLoginURI() {
    this.OAuthLoginURI = this.state.OAuthLoginURI + this.generateState();
  }

  hasValidState(state) {
    const savedUUID = this.LocalStorage.getLoginStateUUID();
    return savedUUID && state && savedUUID === state;
  }

  // --- действия после входа ---

  async checkForEndpointsAsync() {
    try {
      const endpoints = await this.EndpointService.endpoints(0, 1);
      const isAdmin = this.Authentication.isAdmin();

      if (endpoints.value.length === 0 && isAdmin) {
        return this.$state.go('shbdeployer.wizard');
      } else {
        return this.$state.go('shbdeployer.home');
      }
    } catch (err) {
      this.error(err, 'Не удалось получить список окружений');
    }
  }

  async checkForLatestVersionAsync() {
    let versionInfo = {
      UpdateAvailable: false,
      LatestVersion: '',
    };

    try {
      const versionStatus = await this.StatusService.version();
      if (versionStatus.UpdateAvailable) {
        versionInfo.UpdateAvailable = true;
        versionInfo.LatestVersion = versionStatus.LatestVersion;
      }
    } finally {
      this.StateManager.setVersionInfo(versionInfo);
    }
  }

  async postLoginSteps() {
    await this.StateManager.initialize();

    await this.checkForEndpointsAsync();
    await this.checkForLatestVersionAsync();
  }

  // --- способы входа ---

  async oAuthLoginAsync(code) {
    try {
      await this.Authentication.OAuthLogin(code);
      this.URLHelper.cleanParameters();
    } catch (err) {
      this.error(err, 'Не удалось выполнить вход через OAuth');
    }
  }

  async internalLoginAsync(username, password) {
    await this.Authentication.login(username, password);
    await this.postLoginSteps();
  }

  // --- аутентификация пользователя ---

  async authenticateUserAsync() {
    try {
      var username = this.formValues.Username;
      var password = this.formValues.Password;
      this.state.loginInProgress = true;
      await this.internalLoginAsync(username, password);
    } catch (err) {
      this.error(err, 'Не удалось выполнить вход. Проверьте имя пользователя и пароль');
    }
  }

  authenticateUser() {
    return this.$async(this.authenticateUserAsync);
  }

  // --- самостоятельная регистрация ---

  async signupUserAsync() {
    try {
      this.state.SignupError = '';
      this.state.signupInProgress = true;
      const email = this.signupFormValues.Email;
      const password = this.signupFormValues.Password;
      await this.Authentication.signup(email, password);
      await this.postLoginSteps();
    } catch (err) {
      this.state.SignupError = 'Не удалось зарегистрироваться. Проверьте адрес электронной почты и пароль (не менее 8 символов)';
      this.Notifications.error('Ошибка', err, this.state.SignupError);
    } finally {
      this.state.signupInProgress = false;
    }
  }

  signupUser() {
    return this.$async(this.signupUserAsync);
  }

  toggleSignupForm() {
    this.state.showSignupForm = !this.state.showSignupForm;
    this.state.AuthenticationError = '';
    this.state.SignupError = '';
  }

  // --- инициализация ---
  async manageOauthCodeReturn(code, state) {
    if (this.hasValidState(state)) {
      await this.oAuthLoginAsync(code);
    } else {
      this.error(null, 'Недействительное состояние OAuth. Повторите попытку');
    }
  }

  async authEnabledFlowAsync() {
    try {
      const exists = await this.UserService.administratorExists();
      if (!exists) {
        this.$state.go('shbdeployer.init.admin');
      }
    } catch (err) {
      this.error(err, 'Не удалось проверить наличие учетной записи администратора');
    }
  }

  toggleStandardLogin() {
    this.state.showStandardLogin = !this.state.showStandardLogin;
  }

  async onInit() {
    try {
      const settings = await this.SettingsService.publicSettings();
      this.state.showOAuthLogin = settings.AuthenticationMethod === 3;
      this.state.showStandardLogin = !this.state.showOAuthLogin;
      this.state.enableSelfRegistration = !!settings.EnableSelfRegistration;
      this.state.OAuthLoginURI = settings.OAuthLoginURI;
      this.state.OAuthProvider = this.determineOauthProvider(settings.OAuthLoginURI);

      const code = this.URLHelper.getParameter('code');
      const state = this.URLHelper.getParameter('state');
      if (code && state) {
        await this.manageOauthCodeReturn(code, state);
        this.generateOAuthLoginURI();
        return;
      }
      if (!this.logo) {
        await this.StateManager.initialize();
        this.logo = this.StateManager.getState().application.logo;
        this.product = getProductInfo();
      }
      this.generateOAuthLoginURI();

      if (this.$stateParams.logout || this.$stateParams.error) {
        this.logout(this.$stateParams.error);
        return;
      }
      const error = this.LocalStorage.getLogoutReason();
      if (error) {
        this.state.AuthenticationError = error;
        this.LocalStorage.cleanLogoutReason();
      }

      if (this.Authentication.isAuthenticated()) {
        await this.postLoginSteps();
      }
      this.state.loginInProgress = false;

      await this.authEnabledFlowAsync();
    } catch (err) {
      this.Notifications.error('Ошибка', err, 'Не удалось получить публичные настройки');
    }
  }

  $onInit() {
    return this.$async(this.onInit);
  }
}

export default AuthenticationController;
angular.module('shbdeployer.app').controller('AuthenticationController', AuthenticationController);
